import React, { useEffect, useState } from "react";
import { Card, Input, Select, Button, Row, Col, Tabs, Table, message, Form, Tag, Modal, } from "antd";
import { SetEnquiry, getAllInternalUsers, getServiceCentersList, getServiceenquiries, ClosedEnquiries, UserEnquiries, getUserServiceenquiries, ClosedUserEnquiries } from "../../../services/apiService";
import { stateList } from "../../../services/Cart";
import { EditFilled, EditOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const { Option } = Select;
const { TextArea } = Input;
const { TabPane } = Tabs;
const { Search } = Input;

const AssignService = ({ setActiveTab, setSelectedRecord }) => {
  const [form] = Form.useForm();
  const [enquiries, setEnquiries] = useState([])
  const [loading, setLoading] = useState(false)
  const [services, setServices] = useState([]);
  const [states, setStates] = useState([]);
  const [loadingStates, setLoadingStates] = useState(false);
  const [data, setData] = useState([])
  const [closeddata, setClosedData] = useState([])
  const [users, setUsers] = useState([]);
  const [formloading, setformloading] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);
  const serviceType = Form.useWatch("servicetype", form);
  const [usertype, setUsertype] = useState('')
  const [searchValue, setSearchValue] = useState("");
  const [filteredData, setFilteredData] = useState(enquiries);
  const today = new Date().toISOString().split("T")[0];
  const [processdates, setProcessDates] = useState({
    fromDate: today,
    toDate: today,
  });
  const [dates, setDates] = useState({
    fromDate: today,
    toDate: today,
  });
  const navigation = useNavigate()
  const isPurchase = serviceType === "Purchase";
  useEffect(() => {
    form.setFieldsValue({
      serviceperson: undefined, // reset field
    });
  }, [serviceType]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setDates((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleprodateChange = (e) => {
    const { name, value } = e.target;

    setProcessDates((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  useEffect(() => {
    const userid = localStorage.getItem('userType')
    setUsertype(userid)
    if (userid === "Marketing Manager")
       { loaduserEnquries();
         fetchClosedUserEnquiries()     
     }
    else {
       loadEnquiries();
      fetchClosedEnquiries() }
    fetchStates();
    fetchServiceCenters();
    fetchUsers();
  }, [formloading, dates, processdates]);
  const fetchUsers = async () => {
    try {
      const data = await getAllInternalUsers();
      setUsers(data.Data || []);
    } catch (error) {
      console.error("Failed to fetch users:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Filter every time searchValue changes
    if (!searchValue) {
      setFilteredData(enquiries); // no filter, show all
    } else {
      const filtered = enquiries.filter((item) =>
        item.mobilenumber.toLowerCase().includes(searchValue.toLowerCase())
      );
      setFilteredData(filtered);
    }
  }, [searchValue, enquiries]);


  const fetchServiceCenters = async () => {
    try {
      setLoading(true);
      const res = await getServiceCentersList();
      setData(res.data || []);
      console.log("sercen", res.data);
    } catch (error) {
      console.error("Warranty list error:", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchClosedEnquiries = async () => {
    try {
      setLoading(true);
      const res = await ClosedEnquiries(dates.fromDate, dates.toDate);
      setClosedData(res.data || []);
      console.log("sercen", res.data);
    } catch (error) {
      console.error("Warranty list error:", error);
    } finally {
      setLoading(false);
    }
  };
   const fetchClosedUserEnquiries = async () => {
    try {
      setLoading(true);
      const res = await ClosedUserEnquiries(localStorage.getItem('userId'),dates.fromDate, dates.toDate);
      setClosedData(res.data || []);
      console.log("sercen", res.data);
    } catch (error) {
      console.error("Warranty list error:", error);
    } finally {
      setLoading(false);
    }
  };

  const loadEnquiries = async () => {
    try {
      setLoading(true);
      const res = await getServiceenquiries(processdates.fromDate, processdates.toDate);
      console.log(res)
      setEnquiries(res.data || []);
    } catch (e) {
      console.error("Error loading product spares:", e);
    } finally {
      setLoading(false);
    }
  };
  const loaduserEnquries = async (id) => {
    try {
      const payload = {
        id: localStorage.getItem('userId')
      };

      const response = await getUserServiceenquiries(localStorage.getItem('userId'),processdates.fromDate, processdates.toDate);
      console.log("usersenqui", response)
      if (response) {
        setEnquiries(response.data || []);
        // message.success("Service request submitted successfully");
      } else {
        // message.error("Failed to submit request");
      }
    } catch (err) {
      console.error("API Error:", err);
      // better error handling
      message.error(
        err?.response?.data?.message || "Something went wrong. Please try again"
      );
    }
  };


  const onFinish = async (values) => {
    setformloading(true)
    try {
      const payload = {
        ...values,
        date: new Date().toISOString(),
        status: 'Created'
      };

      console.log("Submitting:", payload); // debug

      const response = await SetEnquiry(payload);


      message.success("Service request submitted successfully");
      form.resetFields();

      setformloading(false)
    } catch (err) {
      console.error("API Error:", err);
      setformloading(false)
      // better error handling
      message.error(
        err?.response?.data?.message || "Something went wrong. Please try again"
      );
    }
  };

  const fetchStates = async () => {
    setLoadingStates(true);
    try {
      const response = await stateList();
      console.log("Full API response:", response.data.List);
      setStates(response.data?.List)
      if (response.data?.List?.length === 0) {
        console.warn("No states found in the response");
        showSnackbar("No states available", "info");
      }
    } catch (error) {
      console.error("Error fetching states:", error);
      showSnackbar("Failed to load states", "error");
    } finally {
      setLoadingStates(false);
    }
  };
  const handleEdit = (record) => {
    setEditingRecord(record);
    setIsModalOpen(true);
    getUserEnquiry(record.id)

    form.setFieldsValue({
      customername: record.customername,
      mobilenumber: record.mobilenumber,
      city: record.city,
      state: record.state,
      servicetype: record.servicetype,
      serviceperson: record.serviceperson,
      priority: record.priority,
      discription: record.discription,
      date: new Date().toISOString(),
      status: record.status,
      shifted: record.id
    });
  };

  const columns = [
    { title: "ID", dataIndex: "id" },
    { title: "Ticket ID", dataIndex: "ticketid" },
    { title: "Customer Name", dataIndex: "customername" },
    { title: "Mobile", dataIndex: "mobilenumber" },
    { title: "City", dataIndex: "city" },
    { title: "State", dataIndex: "state" },
    { title: "Service Type", dataIndex: "servicetype" }, {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button
          type="primary"
          onClick={() => {
            setSelectedRecord(record);   // store record
            setActiveTab("TicketEnquiry"); // switch tab
          }}
        >
          Status
        </Button>),
    }
  ];
  const enquiryColumns = [
    {
      title: "Customer Name",
      dataIndex: "customername",
      key: "customername",
    },
    {
      title: "Customer Mobile ",
      dataIndex: "mobilenumber",
      key: "mobilenumber",
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
    },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
    },
    {
      title: "Service Type",
      dataIndex: "servicetype",
      key: "servicetype",
    },
   ...(usertype !== "Marketing Manager"
    ? [
        {
          title: "Service Person",
          dataIndex: "first_name",
          key: "serviceperson",
        },
        {
          title: "Service Mobile",
          dataIndex: "mobile",
          key: "servicemobile",
        },
      ]
    : []),
    // {
    //   title: "Priority",
    //   dataIndex: "priority",
    //   key: "priority",
    //   render: (priority) => {
    //     let color = "blue";
    //     if (priority === "High") color = "red";
    //     else if (priority === "Medium") color = "orange";
    //     else if (priority === "Low") color = "green";

    //     return <Tag color={color}>{priority}</Tag>;
    //   },
    // },
    {
      title: "TicketId",
      dataIndex: "ticketid",
      key: "discription",
      // ellipsis: true,
    },
    // {
    //   title: "Date",
    //   dataIndex: "date",
    //   key: "date",
    //   render: (date) => {
    //     if (!date) return "-";
    //     const d = new Date(date);
    //     return `${String(d.getDate()).padStart(2, "0")}/${String(
    //       d.getMonth() + 1
    //     ).padStart(2, "0")}/${d.getFullYear()}`;
    //   },
    // },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",
    // },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button
          type="primary"
          onClick={() => {
            setSelectedRecord(record);   // store record
            setActiveTab("TicketEnquiry"); // switch tab
          }}
        >
          Status
        </Button>),
    }
  ];
  // const handleSave = (values) => {
  //   const updatedData = data.map((item) =>
  //     item.key === editingRecord.key ? { ...item, ...values } : item
  //   );

  //   setData(updatedData);
  //   setIsModalOpen(false);
  // };

  const filterData = (status) =>
    services.filter((item) => item.status === status);

  return (<>
    <Tabs defaultActiveKey="1">

      {/* CREATE REQUEST TAB */}
      {usertype != 'Marketing Manager' &&
        <TabPane tab="Create Request" key="1">
          <Card title="New Service Request">
            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              initialValues={{ priority: "Normal" }}
            >
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label="Customer Name"
                    name="customername"
                    rules={[{ required: true, message: "Enter customer name" }]}
                  >
                    <Input placeholder="Enter Customer Name" />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    label="Mobile No"
                    name="mobilenumber"
                    rules={[
                      { required: true, message: "Enter mobile number" },
                      { pattern: /^[0-9]{10}$/, message: "Enter valid 10-digit number" },
                    ]}
                  >
                    <Input placeholder="Enter Mobile Number" />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label="City"
                    name="city"
                    rules={[{ required: true, message: "Enter city" }]}
                  >
                    <Input placeholder="Enter City" />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    label="State"
                    name="state"
                    rules={[{ required: true, message: "Enter state" }]}
                  >
                    <Select placeholder="Select State">
                      {states
                        .sort((a, b) => a.statename.localeCompare(b.statename))
                        .map((s) => (
                          <Option key={s.statename} value={s.statename}>
                            {s.statename}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label="Service Type"
                    name="servicetype"
                    rules={[{ required: true, message: "Select service type" }]}
                  >
                    <Select placeholder="Select Service Type">
                      <Option value="Purchase">Purchase</Option>
                      <Option value="Service">Service</Option>
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    label={isPurchase ? "Marketing Person" : "Service Person"}
                    name="serviceperson"
                    rules={[{ required: true, message: "Select service person" }]}
                  >
                    <Select
                      placeholder={
                        isPurchase ? "Select Marketing Person" : "Select Service Person"
                      }
                    >
                      {isPurchase
                        ? users
                          .filter((p) => p.usertype === "Marketing Manager")
                          .map((p) => (
                            <Option key={p.id} value={p.id}>
                              {p.username}
                            </Option>
                          ))
                        : data.map((p) => (
                          <Option key={p.id} value={p.id}>
                            {p.username}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label="Priority"
                    name="priority"
                    rules={[{ required: true, message: "Select priority" }]}
                  >
                    <Select>
                      <Option value="High">High</Option>
                      <Option value="Normal">Normal</Option>
                      <Option value="Low">Low</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Form.Item
                label="Description"
                name="discription" // keep same as backend OR rename everywhere
                rules={[{ required: true, message: "Enter description" }]}
              >
                <TextArea rows={2} placeholder="Describe Issue" />
              </Form.Item>

              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Form>
          </Card>
        </TabPane>}

      {/* NEW TAB */}
      <TabPane tab="In-Process" key="2">

        <Input
          placeholder="Enter Mobile Number"
          size="large"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          style={{ marginBottom: 20, maxWidth: 400 }}
        />
        <div
          style={{
            display: "flex",
            gap: 20,
            alignItems: "center",
            padding: 20,
            background: "#fff",
            borderRadius: 12,
            boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
            width: "fit-content",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={{ fontSize: 13, marginBottom: 5, color: "#555" }}>
              From Date
            </label>
            <input
              type="date"
              name="fromDate"
              value={processdates.fromDate}
              onChange={handleprodateChange}
              style={{
                padding: "8px 12px",
                borderRadius: 8,
                border: "1px solid #ddd",
                outline: "none",
                fontSize: 14,
              }}
            />
          </div>

          {/* To Date */}
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={{ fontSize: 13, marginBottom: 5, color: "#555" }}>
              To Date
            </label>
            <input
              type="date"
              name="toDate"
              value={processdates.toDate}
              onChange={handleprodateChange}
              style={{
                padding: "8px 12px",
                borderRadius: 8,
                border: "1px solid #ddd",
                outline: "none",
                fontSize: 14,
              }}
            />
          </div>
        </div>

        {/* Table */}
        <Table
          columns={enquiryColumns}
          dataSource={filteredData}
          rowKey={(record) => record.id || record.mobilenumber}
          pagination={{ pageSize: 10 }}
        />
      </TabPane>

      {/* RESOLVED TAB */}
      <TabPane tab="Closed" key="3">
        <div
          style={{
            display: "flex",
            gap: 20,
            alignItems: "center",
            padding: 20,
            background: "#fff",
            borderRadius: 12,
            boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
            width: "fit-content",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={{ fontSize: 13, marginBottom: 5, color: "#555" }}>
              From Date
            </label>
            <input
              type="date"
              name="fromDate"
              value={dates.fromDate}
              onChange={handleChange}
              style={{
                padding: "8px 12px",
                borderRadius: 8,
                border: "1px solid #ddd",
                outline: "none",
                fontSize: 14,
              }}
            />
          </div>

          {/* To Date */}
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={{ fontSize: 13, marginBottom: 5, color: "#555" }}>
              To Date
            </label>
            <input
              type="date"
              name="toDate"
              value={dates.toDate}
              onChange={handleChange}
              style={{
                padding: "8px 12px",
                borderRadius: 8,
                border: "1px solid #ddd",
                outline: "none",
                fontSize: 14,
              }}
            />
          </div>
        </div>
        <Table rowKey="id" columns={columns} dataSource={closeddata} />
      </TabPane>

    </Tabs>
  </>
  );
};

export default AssignService;
